import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
import I18n from 'I18n';
import { useGeolocations } from '../geolocationQueries';
import { useCallback } from 'react';
import SearchSelect from '../../../components/SearchSelect';

const mapLocationToOption = ({
  displayName,
  id
}) => ({
  text: displayName,
  value: id
});

const mapOptionToLocation = ({
  text,
  value
}) => ({
  displayName: text,
  id: value
});

const GeolocationSelect = ({
  value,
  placeholder,
  onChange = () => {}
}) => {
  const handleChange = v => {
    onChange(v ? mapOptionToLocation(v) : null);
  };

  const valueAsOption = value ? mapLocationToOption(value) : null;
  const {
    getGeolocations
  } = useGeolocations();
  const handleLoadMore = useCallback((input, callback, pagination = {
    offset: 0
  }) => {
    getGeolocations(input, pagination.offset).then(data => {
      callback(null, {
        options: data.results.map(mapLocationToOption),
        pagination: {
          hasMore: data.hasMore,
          length: data.total,
          offset: data.offset
        }
      });
    });
  }, [getGeolocations]);
  return /*#__PURE__*/_jsx(SearchSelect, {
    "aria-label": I18n.text('connectDotCom.locationSearch'),
    "data-test-id": "location-search-input",
    placeholder: placeholder,
    onChange: handleChange,
    value: valueAsOption,
    loadOptions: handleLoadMore
  });
};

export default GeolocationSelect;